import Cookies from 'js-cookie'

import {
  COOKIE_MAX_AGE,
  COOKIE_NAME,
} from '@maestro/algolia-insights/constants'
import { generateUUID } from '@maestro/algolia-insights/utils'

function isSecureContext(): boolean {
  return typeof window !== 'undefined' && window.location?.protocol === 'https:'
}

function getCookieOptions() {
  return {
    expires: COOKIE_MAX_AGE,
    sameSite: 'Lax' as const,
    secure: isSecureContext(),
  }
}

export const userTokenCookieService = {
  get(): string | undefined {
    return Cookies.get(COOKIE_NAME)
  },

  set(token: string): void {
    Cookies.set(COOKIE_NAME, token, getCookieOptions())
  },

  remove(): void {
    Cookies.remove(COOKIE_NAME, {
      sameSite: 'Lax',
      secure: isSecureContext(),
    })
  },

  getOrCreate(): string {
    let token = this.get()
    if (!token) {
      token = generateUUID()
      this.set(token)
    }
    return token
  },
}
